<template src='./belvoWidget.pug' lang='pug' />
<script>

import axios from '../../../../../build/http-requests/axios-common.js'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import customValidator from '../../../../utils/customValidator.js'
import { getBelvoInstitutionsByCdBankPersonType } from '../../../../enum/codigoBancoBelvo.js'
import { TheMask } from 'vue-the-mask'
import { ToggleButton } from 'vue-js-toggle-button'
import { Validator } from 'vee-validate'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'BelvoWidget',

  props: {
    showOpenFinance: {
      type: Boolean,
      default: false
    },
    bankAccount: {
      type: Object,
      required: true
    },
    linkOFDA: {
      type: String
    }
  },

  components: {
    ButtonPrimary,
    TheMask,
    ToggleButton
  },

  watch: {
    bankAccount: {
      handler () {
        this.enableOfdaForm = !!(this.bankAccount && this.bankAccount.optIn && this.bankAccount.optIn.id)
      },
      deep: true
    }
  },

  data () {
    return {
      belvoToken: {},
      cpf: null,
      cnpj: null,
      requisitante: '',
      empresa: '',
      tipoConta: 'PF',
      link: null,
      enableOfdaForm: false
    }
  },

  methods: {
    activeWidgetBelvo () {
      let institutionsList = getBelvoInstitutionsByCdBankPersonType(this.bankAccount.bank.codigo, this.tipoConta)
      if (institutionsList.length <= 0) {
        this.$root.$refs.notification.warning(this.$t('ofda.nenhumaInstituicaoHomologada'))
        this.$store.dispatch('setHasUnsavedChanges', false)
        this.$store.dispatch('cleanBankAccountToEdit')
        location.href = PATHS.LIST_BANK_ACCOUNTS
      } else {
        return new Promise((resolve, reject) => {
          let body = {
            user: {
              name: this.requisitante,
              registration: this.cpf
            },
            bankAccountData: this.bankAccount.bank.codigo + '|' + this.bankAccount.agency + '|' + this.bankAccount.accountNumber
          }

          if (this.tipoConta === 'PJ') {
            body.company = {
              name: this.empresa,
              registration: this.cnpj
            }
          }

          axios.post('/ofda/generateOFDAAccess', body).then((response) => {
            this.belvoToken = response.data
            this.createWidget()
            resolve()
          }).catch((err) => {
            this.$root.$refs.notification.error(err.message)
            reject()
          })
        })
      }
    },

    createWidget () {
      const successCallbackFunction = (link, institution) => {
      }
      const onExitCallbackFunction = (data) => {
      }
      const onEventCallbackFunction = (data) => {
      }

      const config = {
        integration_type: 'openfinance',
        callback: (link, institution) => successCallbackFunction(link, institution),
        onExit: (data) => onExitCallbackFunction(data),
        onEvent: (data) => onEventCallbackFunction(data),
        country_codes: ['BR'],
        locale: 'pt',
        institutions: getBelvoInstitutionsByCdBankPersonType(this.bankAccount.bank.codigo, this.tipoConta),
        show_close_dialog: true,
        show_abandon_survey: true,
        institution_types: ['retail', 'business']
      }
      window.belvoSDK.createWidget(this.belvoToken.access, config).build()
    },

    loadScript (src) {
      const node = document.createElement('script')
      node.src = src
      node.type = 'text/javascript'
      node.async = true
      // Assign the callback which will create the Widget
      node.onload = this.createWidget
      // Add script to document body
      document.body.appendChild(node)
    }
  },

  created () {
    this.requisitante = this.$store.getters.user
    this.empresa = this.$store.getters.clientName

    Validator.extend('cnpjValido', {
      getMessage: field => this.$t('estabelecimentos.erro.cnpjInvalido'),
      validate: value => customValidator.validateCnpj(value)
    })

    Validator.extend('cpfValido', {
      getMessage: field => this.$t('estabelecimentos.erro.cpfInvalido'),
      validate: value => customValidator.validateCpf(value)
    })
  },

  mounted () {
    this.loadScript('https://cdn.belvo.io/belvo-widget-1-stable.js')
  }
}
</script>
<style>
.open-finance {
  font-family: 'Inter', sans-serif;
  text-transform: initial !important;
  font-size: 15px;
  color: #147d96;
}

.open-finance-box{
  border: 2px solid #147d96;
  border-radius: 10px;
  padding-left: 1vh;
  padding-right: 1vh;
  padding-top: 1vh;
}

.open-finance.primary {
  background-color: #147d96 !important;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// BelvoWidget.vue?62ad6740